import Page from "../../components/GlobalComponent/PageComponent";
import React, {useEffect, useState} from "react";
import {SailingScheduleBreadcrumb} from "../../common/data/parties";
import StatsSummary from "../../components/GlobalComponent/StatsSummaryComponent";
import RouteFinderTabs from "./components/RouteFinderTabs";
import SearchForm from "./components/SearchForm";
import RouteResults from "./components/RouteProgress";
import FilterSidebar from "./components/FilterSidebar";
import { useDispatch } from "react-redux";
import { getInstantRateLocation } from "../../store/InstantRate/actions";
import {useFormik} from "formik";
import { getSailingSchedule } from "../../store/Global/actions";
import { useSelector } from "react-redux";
import SailingScheduleItems from "./components/SailingScheduleItems";

const SailingSchedule = () => {

    const dispatch = useDispatch();
    const { sailingScheduleData, sailingScheduleDataError, sailingScheduleDataLoader } = useSelector((state) => state?.globalReducer);

    useEffect(() => {
        dispatch(getInstantRateLocation());
    }, [dispatch]);

    

    const myInquiriesStatsData = [];
    const [activeTab, setActiveTab] = useState('route');
    const [searchResults, setSearchResults] = useState();


    useEffect(() => {
        setSearchResults(sailingScheduleData?.data?.data?.schedules || [])
    }, [sailingScheduleData, sailingScheduleDataError, sailingScheduleDataLoader]);

    const handleFilterChange = (filters) => {
        console.log('Filter data:', filters);
        // In a real app, we would update results based on filters
    };

    const sailingScheduleFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            location_from: '',
            location_to: '',
            searchDate: '',
        },
        onSubmit: (values) => {
            console.log(values);
            let payload = {
                "startDate": values?.searchDate,
                "mode": "OCEAN",
                "originId": Number(values?.location_from?.value),
                "destinationId": Number(values?.location_to?.value),
                "destination":values?.location_to?.locationCode || '',
                "origin":values?.location_from?.locationCode || ''
            }
            dispatch(getSailingSchedule(payload));
        }
    })

    return(
        <Page>
            <StatsSummary
                breadcrumb={SailingScheduleBreadcrumb}
                stats={myInquiriesStatsData}
            />
            <div className="w-100 py-4">
                <div className="mb-4">
                    <div className="row mb-3">
                        <div className="col-12">
                            <RouteFinderTabs active={activeTab} setActive={setActiveTab} />
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-12">
                            <SearchForm onSearch={sailingScheduleFormik} tabName={activeTab} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-3 mb-4 mb-lg-0">
                            <FilterSidebar onFilterChange={handleFilterChange} />
                        </div>

                        <div className="col-lg-9">                            
                            <RouteResults routes={searchResults || []} />
                            <div className="mt-3 text-center">
                                <button className="btn btn-outline-primary btn-sm rounded-pill">
                                    Load More
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </Page>
    );
}

export default SailingSchedule;
